import InnerComponent from '@Components/Production/MRPV2/MrpListV2';
import orgContainer from '@Components/AppContainer';

const MrpListV2 = () => ((orgContainer(InnerComponent)));
export default MrpListV2;
